export default {"src":"/_next/static/media/white-bath.73f67909.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};